import React, { useEffect, useMemo, useState } from "react";
import { Col, Empty, Form, Row, Spin } from "antd";
import { DisplayInput } from "components";
import { AiccOnboardingProfile } from "types/model/aiccCustomer";
import * as aiccAPI from "services/aiccCustomer";
import styles from "./Onboarding.module.scss";

interface Props {
  subUserId: string;
  languageId: number;
  languageName?: string;
}

const FULL_ROW_SPAN = 24;
const HALF_ROW_SPAN = 12;

interface Field {
  label: string;
  key: keyof AiccOnboardingProfile;
  span?: number;
}

const getFields = (languageName?: string): Field[] => [
  { label: "Nickname", key: "preferredName" },
  { label: "Preferred Gender", key: "preferredGender" },
  { label: "Preferred Topics", key: "preferredTopics" },
  { label: `${languageName ?? ""} Experience`.trim(), key: "previousExperience" },
  { label: "Learning Motivation", key: "learningMotivation" },
  { label: "Confidence Level", key: "confidenceLevel" },
  { label: "Other", key: "other", span: FULL_ROW_SPAN },
];

function Onboarding({ subUserId, languageId, languageName }: Props) {
  const [isLoading, setIsLoading] = useState(false);
  const [profile, setProfile] = useState<AiccOnboardingProfile>();

  const fields = useMemo(() => getFields(languageName), [languageName]);

  useEffect(() => {
    setIsLoading(true);
    aiccAPI
      .fetchAiccOnboardingProfile(subUserId, languageId)
      .then(setProfile)
      .catch(() => setProfile(undefined))
      .finally(() => setIsLoading(false));
  }, [subUserId, languageId]);

  return (
    <Spin spinning={isLoading}>
      {profile ? (
        <div className={styles.onboardingSection}>
          <Form layout="vertical">
            <Row gutter={32}>
              {fields.map(({ label, key, span }) => (
                <Col span={span ?? HALF_ROW_SPAN} key={key}>
                  <Form.Item label={label}>
                    <DisplayInput value={profile[key]} />
                  </Form.Item>
                </Col>
              ))}
            </Row>
          </Form>
        </div>
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      )}
    </Spin>
  );
}

export default Onboarding;
